import { Theme } from '@themes/theme'
import { css } from '@emotion/core'

export const ItemShopModalTit = (theme:Theme) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${theme.font.title};
  font-weight: ${theme.fontW.bold};
  color: ${theme.color.mainBg};
  svg {
    width: 18px;
    margin: 0 5px;
  }
`
export const rowStyle = (theme:Theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 3.6rem;
  color: ${theme.color.mainBg};
  font-size: ${theme.font.large};
  &.quantity {
    margin: 0 25px 10px 90px;
  }
  &.price {
    margin: 0 25px 0 48px;
  }
  .white-input {
    width: 108px;
    height: 36px;
    line-height: 3.6rem;
    input {
      font-size: ${theme.font.title};
    }
  }
  .price {
    display: flex;
    align-items: center;
    color: ${theme.color.mainBg};
    font-size: ${theme.font.title};
    svg {
      width: 18px;
      margin-left: 4px;
    }
  }
`
